import { Box, SxProps, Theme } from '@mui/material';
import { baseColors } from 'utils/constants';

type Props = {
  id?: string;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
};

const ShadowBox = ({ sx, children, onClick }: Props) => (
  <Box
    onClick={onClick}
    sx={{
      bgcolor: baseColors.white,
      borderRadius: 2,
      boxShadow: '0 0 3px 3px rgba(0, 0, 0, 0.1)',
      width: '100%',
      mx: 'auto',
      my: 0,
      p: 2,
      cursor: onClick ? 'pointer' : 'inherit',
      ...sx
    }}
  >
    {children}
  </Box>
);

export default ShadowBox;
